import React from "react"
import { View, Chip } from "react-ame-components"
import ShowCase from "../components/Showcase"

export class ChipExample extends React.Component {
  state = {
    data: [
      {
        id: 1,
        label: "label 1",
        value: "chip-7",
        variant: "secondary",
      },
      {
        id: 2,
        label: "label 2",
        value: "chip-8",
        icon: "",
        variant: "secondary",
      },
    ],
  }
  render() {
    return (
      <ShowCase
        centerGrid
        title="Componente Chip"
        description="Componente perfeito para escolher opções rápidas">
        <View direction="row">
          <Chip
            value="tomate"
            label="Tomate"
            onChange={(value, active) => console.log(`Está ativado? ${active}`)}
            dataCy="chip-teste"
          />
          <Chip
            value="alface"
            label="Alface"
            onChange={e => console.log(e)}
            icon="food-convenience"
            dataCy="chip-teste-icon"
          />
          <Chip
            value="cebola"
            label="Cebola"
            disabled
            onChange={e => console.log(e)}
            dataCy="chip-teste-disabled"
          />
          <Chip
            label="Molho"
            value="molho"
            active
            onChange={e => console.log(e)}
          />
        </View>
      </ShowCase>
    )
  }
}
